/* ===========================================================
   BDR — PAGINE LAVORAZIONE (script)

   Prima stava in fondo a sections/bdr-lavorazione.liquid; e'
   stato spostato qui per tenere la sezione sotto i 25 KB.
   Caricato da snippets/meta-tags.liquid solo sulle pagine
   lavorazione, con defer (parte quando la pagina e' pronta).

   Tre cose:
   1. cursore prima/dopo: l'<input type=range> trasparente
      aggiorna la variabile --p del riquadro;
   2. foto del cliente caricate su Supabase, link nell'email;
   3. scelta multipla "Lavorazione che pensi serva": vedi sotto.
   =========================================================== */
(function(){
  /* cursore prima/dopo */
  document.querySelectorAll('[data-bdr-ba]').forEach(function(box){
    var r = box.querySelector('input[type=range]');
    if(!r) return;
    function set(){ box.style.setProperty('--p', r.value + '%'); }
    r.addEventListener('input', set);
    set();
  });

  /* caricamento foto su Supabase */
  var SB = 'https://ztlrddmryngpwafewria.supabase.co';
  var KEY = 'sb_publishable_EzuF8yAqRlASzhlkqag9cA_YLTXOtXk';
  document.querySelectorAll('[data-bdr-foto]').forEach(function(box){
    var inp = box.querySelector('input[type=file]');
    var hid = box.querySelector('input[type=hidden]');
    var out = box.querySelector('.foto-esito');
    var form = box.closest('form');
    var btn = form ? form.querySelector('button[type=submit]') : null;
    if(!inp) return;
    inp.addEventListener('change', function(){
      var files = [].slice.call(inp.files).slice(0, 6);
      if(!files.length) return;
      var urls = [], fatti = 0, errori = 0;
      var cartella = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      out.className = 'foto-esito';
      out.textContent = 'Carico ' + files.length + (files.length === 1 ? ' file...' : ' file...');
      if(btn) btn.disabled = true;
      files.forEach(function(f){
        var nome = f.name.replace(/[^a-zA-Z0-9._-]/g, '_');
        var via = cartella + '/' + nome;
        fetch(SB + '/storage/v1/object/preventivi/' + via, {
          method: 'POST',
          headers: { apikey: KEY, authorization: 'Bearer ' + KEY, 'x-upsert': 'true' },
          body: f
        }).then(function(r){
          if(!r.ok) throw new Error(r.status);
          urls.push(SB + '/storage/v1/object/public/preventivi/' + via);
        }).catch(function(){
          errori++;
        }).then(function(){
          fatti++;
          if(fatti !== files.length) return;
          hid.value = urls.join('\n');
          if(btn) btn.disabled = false;
          if(urls.length){
            out.className = 'foto-esito ok';
            out.textContent = urls.length + (urls.length === 1 ? ' foto caricata' : ' foto caricate') + (errori ? (', ' + errori + ' non caricate') : '');
          } else {
            out.className = 'foto-esito ko';
            out.textContent = 'Non sono riuscito a caricare le foto. Invia pure la richiesta: te le chiediamo rispondendo via email.';
          }
        });
      });
    });
  });
})();

/* SCELTA MULTIPLA DELLE LAVORAZIONI
   Il modulo contatti di Shopify tiene un solo valore per nome di
   campo: le caselle quindi NON hanno nome, e qui le si riunisce in
   un unico campo nascosto ("Cilindri 2T Ricromatura, Cilindri 2T
   Lappatura"), che nell'email arriva come una riga sola.
   La casella con data-solo ("Non lo so, consigliatemi voi") esclude
   le altre, e viceversa. Nessuna spuntata = vale la prima voce. */
(function(){
  document.querySelectorAll('[data-bdr-multi]').forEach(function(box){
    var hid = box.querySelector('input[type=hidden]');
    var caselle = [].slice.call(box.querySelectorAll('input[type=checkbox]'));
    if(!hid || !caselle.length) return;
    var vuoto = hid.value;
    function aggiorna(){
      var scelte = caselle.filter(function(c){ return c.checked; }).map(function(c){ return c.value; });
      hid.value = scelte.length ? scelte.join(', ') : vuoto;
    }
    caselle.forEach(function(c){
      c.addEventListener('change', function(){
        if(c.checked){
          var solo = c.hasAttribute('data-solo');
          caselle.forEach(function(o){
            if(o !== c && (solo || o.hasAttribute('data-solo'))) o.checked = false;
          });
        }
        aggiorna();
      });
    });
    aggiorna();
  });
})();
